import './InstitutionSelect.less'

import KindergartenIcon from '../../../assets/images/kindergarten_icon.svg'
import PrimaryIcon from '../../../assets/images/primary_icon.svg'
/* import SecondaryIcon from '../../../assets/images/secondary_icon.svg' */

import React, { Component } from 'react'
import { translate } from 'react-i18next'

import { Navigator } from '../Navigator/Navigator'
import { CreateAccountContext } from '../../../contexts/contexts'
/* import { getLocale } from '../../PlatformSwitch/PlatformSwitch' */

const KINDERGARTEN = 'kindergarten'
const PRIMARY = 'primary'

class InstitutionSelect extends Component {
  static contextType = CreateAccountContext

  render() {
    const t = this.props.t

    /* const locale = getLocale() */

    return (
      <div className="inst_select">
        <p>{t('pleaseSelect')}</p>

        <Navigator onBackClick={this.handleNavigatorBackClick} />

        <div className="selector">
          <div className="kindergarten" onClick={this.institutionClickHandler.bind(this, KINDERGARTEN, '111')}>
            <img src={KindergartenIcon} alt="" />
            <p>{t('institution.kindergarten')}</p>
          </div>
          <div className="primary" onClick={this.institutionClickHandler.bind(this, PRIMARY, '211')}>
            <img src={PrimaryIcon} alt="" />
            <p>{t('institution.primary')}</p>
          </div>
          {/* <a className="secondary" href={`https://apps.plantyn.com/my/${locale}/account/register`}>
            <img src={SecondaryIcon} alt="" />
            <p>{t('institution.secondary')}</p>
          </a> */}
        </div>
      </div>
    )
  }

  handleNavigatorBackClick = () => {
    this.context.setRole()
    this.context.setSchool()
    this.props.previousStep()
  }

  institutionClickHandler(institutionName, id) {
    this.context.setInstitution({ id, name: institutionName })
    this.props.nextStep()
  }
}

const translateInstitutionSelect = translate('registration')(InstitutionSelect)

export { translateInstitutionSelect as InstitutionSelect }



// WEBPACK FOOTER //
// ./src/components/CreateAccount/InstitutionSelect/InstitutionSelect.js